import type { CSSProperties } from 'react';

/** Let the grid constrain width; aspect-ratio then shrinks height with it. */
export function chatImageSlotLayout({w,h}: {w:number;h:number}): CSSProperties {
  return {
    width: Math.round(w / h * 96),
    maxWidth: '100%',
    aspectRatio: `${w} / ${h}`,
    alignSelf: 'start',
  };
}
